import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// axios
import axios from "axios";
import VueAxios from "vue-axios";

// session
import VueSession from "vue-session";

// v-mask
import VueMask from "v-mask";

// Sweet Alert
import VueSweetalert2 from "vue-sweetalert2";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
import VueApexCharts from "vue-apexcharts";
import VueQuillEditor from "vue-quill-editor";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// require styles
require("./assets/css/main.css");
require("./assets/css/stylesheet.css");
require("./assets/css/setting.css");

// VUE.USE
Vue.use(VueAxios, axios);
Vue.use(VueSession);
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueQuillEditor);
Vue.use(VueMask);

// CONFIG
Vue.config.productionTip = false;
// Event Bus
export const bus = new Vue();
// EXPORT
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
